import * as React from "react";
import { Avatar, Menu, MenuItem } from "@progress/kendo-react-layout";
import { AppBar, AppBarSection, AppBarSpacer } from "@progress/kendo-react-layout";
import { Notification, NotificationGroup } from "@progress/kendo-react-notification";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import user from '../assets/user.png';
import { GetToken, GetUserName, GetSession } from "../components/Session";
import configData from "../config.json";

export const Header = (props) => {
    const { onButtonClick } = props;

    // State for various notification messages
    const [errorMessage, setErrorMessage] = React.useState("");
    const [warningMessage, setWarningMessage] = React.useState("");
    const [infoMessage, setInfoMessage] = React.useState("");
    const [supportMessage, setSupportMessage] = React.useState();

    // Local storage notification IDs
    let savedIds = [0, 0, 0, 0];
    let ls = localStorage.getItem("Notifications");
    if (ls !== null) savedIds = JSON.parse(ls);

    const latestIds = React.useRef(savedIds);
    const latest = React.useRef([0, 0, 0, 0]);
    const support = React.useRef();

    // State for logs dialog
    const [logsTitle, setLogsTitle] = React.useState();
    const [logData, setLogData] = React.useState([]);

    // Fetch support message on mount
    React.useEffect(() => {
        const baseUrl = `${configData.SERVER_URL}apiV7/support/ViewMessage/${savedIds[0]}`;
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        fetch(baseUrl, init)
            .then((response) => response.json())
            .then((d) => {
                support.current = d;
                setSupportMessage(d.description);
            });
    }, []);

    // Close notification and update stored IDs
    const CloseMessage = (level) => {
        if (latest.current !== undefined && latest.current.length > 0) {
            let logEntry = latest.current.find(obj => obj.level === level);
            if (logEntry !== undefined) {
                let idsCopy = [...latestIds.current];
                switch (level) {
                    case "Error":
                        idsCopy[1] = logEntry.id;
                        setErrorMessage("");
                        break;
                    case "Warning":
                        idsCopy[2] = logEntry.id;
                        setWarningMessage("");
                        break;
                    case "Information":
                        idsCopy[3] = logEntry.id;
                        setInfoMessage("");
                        break;
                }
                latestIds.current = idsCopy;
            }
            if (level === "Support") {
                let idsCopy = [...latestIds.current];
                idsCopy[0] = support.current.supportId;
                latestIds.current = idsCopy;
                setSupportMessage("");
            }
            localStorage.setItem("Notifications", JSON.stringify(latestIds.current));
        }
    };

    // Handle notification click to fetch logs
    const NotificationClicked = (level) => {
        if (level === "Support") return;
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        let url = `${configData.SERVER_URL}apiv7/private/getlogsforlevel?level=${level}`;
        fetch(url, init)
            .then(response => response.json())
            .then(d => {
                setLogsTitle(`${level} Logs`);
                const data = d.map(item => ({
                    timeStamp: new Date(Date.parse(item.timeStamp)),
                    message: item.message,
                }));
                setLogData(data);
            });
    };

    return (
        <AppBar
        className="appBar"
        >
            {/* Menu button section */}
            <AppBarSection>
                <div className="menu-button" style={{ cursor: "pointer" }}>
                    <span className={"k-icon k-i-menu"} onClick={onButtonClick} />
                </div>
            </AppBarSection>

            {/* Spacer to push content apart */}
            <AppBarSpacer style={{ width: 1 }} />

            {/* Removed logo section as requested */}

            {/* Spacer */}
            <AppBarSpacer style={{ width: 40 }} />

            {/* Conditional site ID display */}
            {GetSession().SiteID !== 1 && (
                <AppBarSection style={{ fontSize: "1rem" }}>
                    <div>NMI S627</div>
                </AppBarSection>
            )}

            {/* Spacer */}
            <AppBarSpacer style={{ width: 80 }} />

            {/* Notifications Group */}
            <AppBarSection>
                <NotificationGroup>
                    <div className="row" style={{ display: "flex", gap: "10px" }}>
                        {errorMessage && (
                            <Notification
                                closable
                                onClose={() => CloseMessage("Error")}
                                type={{ style: "error" }}
                                style={{ width: 250, cursor: "pointer" }}
                                onClick={() => NotificationClicked("Error")}
                            >
                                {errorMessage}
                            </Notification>
                        )}
                        {warningMessage && (
                            <Notification
                                closable
                                onClose={() => CloseMessage("Warning")}
                                type={{ style: "warning" }}
                                style={{ width: 250, cursor: "pointer" }}
                                onClick={() => NotificationClicked("Warning")}
                            >
                                {warningMessage}
                            </Notification>
                        )}
                        {infoMessage && (
                            <Notification
                                closable
                                onClose={() => CloseMessage("Information")}
                                type={{ style: "success" }}
                                style={{ width: 250, cursor: "pointer" }}
                                onClick={() => NotificationClicked("Information")}
                            >
                                {infoMessage}
                            </Notification>
                        )}
                        {supportMessage && (
                            <Notification
                                closable
                                onClose={() => CloseMessage("Support")}
                                type={{ style: "info" }}
                                style={{ width: 250, cursor: "pointer" }}
                                onClick={() => NotificationClicked("Support")}
                            >
                                {supportMessage}
                            </Notification>
                        )}
                    </div>

                    {/* Logs dialog */}
                    {logsTitle && (
                        <Dialog title={logsTitle} onClose={() => setLogsTitle()}>
                            <div style={{ maxWidth: 800, maxHeight: 550 }}>
                                <Grid data={logData}>
                                    <Column
                                        field="timeStamp"
                                        title="Time"
                                        editable={false}
                                        format="{0:d/MM/yy hh:mm}"
                                        width={"200px"}
                                    />
                                    <Column field="message" title="Message" editable={false} />
                                </Grid>
                            </div>
                        </Dialog>
                    )}
                </NotificationGroup>
            </AppBarSection>

            {/* Spacer to push menu right */}
            <AppBarSpacer style={{ flexGrow: 1 }} />

            {/* User menu section */}
            <AppBarSection>
                <Menu>
                    <MenuItem
                        render={() => (
                            <Avatar type="image">
                                <img src={user} alt="User Avatar" />
                            </Avatar>
                        )}
                    >
                        <MenuItem text="Account" url="/account" />
                        <MenuItem text="Settings" url="/settings" />
                        <MenuItem text="Task Board" url="/Todos" />
                        <MenuItem text="Change Password" url="/password" />
                        <MenuItem text={`Logout (${GetUserName()})`} url="/Logout" />
                    </MenuItem>
                </Menu>
            </AppBarSection>
        </AppBar>
    );
};